import React from 'react';

/**
 * Icône Développement Web - Style isométrique
 * Représente du code avec symboles < />
 */
const WebDevelopment = ({
  size = 48,
  className = '',
  animate = false
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon-web-dev ${animate ? 'icon-animate' : ''} ${className}`}
    >
      <defs>
        <linearGradient id="webGrad1" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#0066ff" />
          <stop offset="100%" stopColor="#3385ff" />
        </linearGradient>
      </defs>

      {/* Écran/Fenêtre de code */}
      <rect
        x="10"
        y="14"
        width="28"
        height="20"
        rx="2"
        stroke="url(#webGrad1)"
        strokeWidth="2.5"
        fill="url(#webGrad1)"
        fillOpacity="0.1"
      />

      {/* Barre de titre */}
      <line
        x1="10"
        y1="18"
        x2="38"
        y2="18"
        stroke="url(#webGrad1)"
        strokeWidth="2"
        opacity="0.5"
      />

      {/* Symbole < à gauche */}
      <path
        d="M18 24 L14 27 L18 30"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Symbole / au centre */}
      <line
        x1="22"
        y1="30"
        x2="26"
        y2="24"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
      />

      {/* Symbole > à droite */}
      <path
        d="M30 24 L34 27 L30 30"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Points décoratifs (nodes réseau) */}
      <circle cx="12" cy="12" r="1.5" fill="#0066ff" opacity="0.6" />
      <circle cx="36" cy="12" r="1.5" fill="#0066ff" opacity="0.6" />
      <circle cx="36" cy="36" r="1.5" fill="#0066ff" opacity="0.6" />
      <circle cx="12" cy="36" r="1.5" fill="#0066ff" opacity="0.6" />
    </svg>
  );
};

export default WebDevelopment;
